export interface RedirectPartialConfig {
  redirectType: string;
}

export function getCreativeType(formatName: FormatName, creativeConf: any) {
  switch (formatName) {
    case 'Display image':
      if (
        creativeConf.url ||
        (creativeConf.smartphonePortrait &&
          creativeConf.tabletPortrait &&
          creativeConf.tabletLandscape)
      ) {
        return 'image';
      }

      if (creativeConf.creative === 'Url' && creativeConf.previewUrl) {
        return 'url';
      }

    case 'Display redirect':
      return 'mraid';
  }

  return '';
}

export function formatSupportMraidTag(formatName: FormatName) {
  return ['Display redirect'].indexOf(String(formatName)) !== -1;
}

export function getFormatParams(
  format: FormatName,
  formatConfig: any,
  redirectUrl: string,
  adContext: AdContext
): object {
  let params: any = { redirect_url: redirectUrl };

  if (!formatConfig) {
    return params;
  }

  // commons params to track
  switch (format) {
    case 'Display image':
      if (
        adContext?.adUnitType === 'banner_320x50' ||
        adContext?.adUnitType === 'standard_banners'
      ) {
        params = {
          ...params,
          browser: formatConfig.browser?.type,
          interaction: formatConfig.interaction
        };
      }

      if (adContext?.adUnitType === 'interstitial') {
        params = {
          ...params,
          browser: formatConfig.browser?.type,
          close_btn_display_after: formatConfig.closeBtn?.displayAfter,
          close_btn_size: formatConfig.closeBtn?.iconSize,
          confirm_button_show: formatConfig.confirmButton?.show,
          ignore_clicks_before: formatConfig.ignoreClicksBefore,
          interaction: formatConfig.interaction,
          percent_show: formatConfig.discover?.show,
          use_icon: formatConfig.icon?.useIcon
        };
      }

      break;
    case 'Browser':
      params = {
        ...params,
        browser_keep_alive: formatConfig.keepAlive,
        content_discovery:
          formatConfig.contentDiscovery?.useContentDiscovery &&
          formatConfig.contentDiscovery?.hasImage,
        recommended_links:
          !formatConfig.contentDiscovery?.useContentDiscovery &&
          formatConfig.recommendedLinks?.useRecommendedLinks &&
          formatConfig.recommendedLinks?.hasImage,
        recommended_urls: formatConfig.alternativeUrls?.urls?.length !== 0,
        recommended_urls_timeout: formatConfig.alternativeUrls?.timeout
      };
      break;
    case 'Display redirect':
      params = {
        ...params,
        browser: formatConfig.browser?.type,
        use_icon: formatConfig.icon?.useIcon
      };
      break;
    case 'Video':
      params = {
        ...params,
        browser: formatConfig.browser?.type,
        close_btn_display_after: formatConfig.closeBtn?.displayAfter,
        close_btn_size: formatConfig.closeBtn?.size,
        display_sound_button: formatConfig.controls?.sound?.enabled,
        interaction: formatConfig.interaction,
        on_skip_confirmation_display: formatConfig.confirmSkip?.enabled,
        skin_bottom: Boolean(formatConfig.skin?.skinBottom),
        skin_top: Boolean(formatConfig.skin?.skinTop),
        skin_end_screen_image: Boolean(formatConfig.skin?.endScreenImage),
        skin_end_screen_html: Boolean(formatConfig.skin?.endScreenHtml),
        skip_or_continue_after_delay_delay: formatConfig.skipAfterDelay?.delay,
        skip_or_continue_after_delay_display:
          formatConfig.skipAfterDelay?.enabled,
        sound_on_start: formatConfig.video?.soundOnStart,
        video_close_delay: formatConfig.closeBtn?.closeDelay
      };
      break;
    case 'Recommended Links':
      params = {
        ...params,
        recommended_links_acd: formatConfig.recommendedLinks?.autoCloseDuration
      };
      break;
    case 'Content Discovery':
      params = {
        ...params,
        content_discovery_acd: formatConfig.contentDiscovery?.autoCloseDuration
      };
      break;
    default:
      break;
  }

  return params;
}

export function extractZoneFromElement(
  elem: any,
  attributeName: string = 'data-zone'
): string {
  if (!elem) {
    return 'unknown';
  }
  return (
    elem.getAttribute(attributeName) ||
    extractZoneFromElement(elem.parentElement, attributeName)
  );
}

export function isCeltraCreative(formatConfig: RedirectPartialConfig) {
  return formatConfig?.redirectType === 'celtra';
}

export function isOCSCreative(formatConfig: RedirectPartialConfig) {
  return formatConfig?.redirectType === 'ocs';
}

export function isFlashtalkingCreative(formatConfig: RedirectPartialConfig) {
  return formatConfig?.redirectType === 'flashtalking';
}

export function isDcmCreative(formatConfig: RedirectPartialConfig) {
  return formatConfig?.redirectType === 'dcm';
}
